import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_wildsky_common_proto from './dcei_wildsky_common_proto';
class CampaignData_Level {
  get descriptor() {
    return CampaignData_Level.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasMapKey = false;
    this._mapKey = null;
    this._hasChallengeMapKey = false;
    this._challengeMapKey = null;
    this._hasNewPlayerMapKey = false;
    this._newPlayerMapKey = null;
    this._hasRequiredLevel = false;
    this._requiredLevel = null;
    this._hasIsBossLevel = false;
    this._isBossLevel = null;
    this._hasConsumableItemKey = false;
    this._consumableItemKey = null;
  }
  isEmpty() {
    if (this._hasMapKey) return false;
    if (this._hasChallengeMapKey) return false;
    if (this._hasNewPlayerMapKey) return false;
    if (this._hasRequiredLevel) return false;
    if (this._hasIsBossLevel) return false;
    if (this._hasConsumableItemKey) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CampaignData_Level) {
      return value;
    }
    return CampaignData_Level.fromJson(value);
  }
  static fromJson(json) {
    const result = new CampaignData_Level();
    if (json.mapKey != null) {
      result._hasMapKey = true;
      result._mapKey = JsonToString.fromJson(json.mapKey);
    }
    if (json.challengeMapKey != null) {
      result._hasChallengeMapKey = true;
      result._challengeMapKey = JsonToString.fromJson(json.challengeMapKey);
    }
    if (json.newPlayerMapKey != null) {
      result._hasNewPlayerMapKey = true;
      result._newPlayerMapKey = JsonToString.fromJson(json.newPlayerMapKey);
    }
    if (json.requiredLevel != null) {
      result._hasRequiredLevel = true;
      result._requiredLevel = JsonToInt32.fromJson(json.requiredLevel);
    }
    if (json.isBossLevel != null) {
      result._hasIsBossLevel = true;
      result._isBossLevel = JsonToBoolean.fromJson(json.isBossLevel);
    }
    if (json.consumableItemKey != null) {
      result._hasConsumableItemKey = true;
      result._consumableItemKey = JsonToString.fromJson(json.consumableItemKey);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasMapKey) {
      result.mapKey = JsonToString.toJson(this._mapKey);
    }
    if (this._hasChallengeMapKey) {
      result.challengeMapKey = JsonToString.toJson(this._challengeMapKey);
    }
    if (this._hasNewPlayerMapKey) {
      result.newPlayerMapKey = JsonToString.toJson(this._newPlayerMapKey);
    }
    if (this._hasRequiredLevel) {
      result.requiredLevel = JsonToInt32.toJson(this._requiredLevel);
    }
    if (this._hasIsBossLevel) {
      result.isBossLevel = JsonToBoolean.toJson(this._isBossLevel);
    }
    if (this._hasConsumableItemKey) {
      result.consumableItemKey = JsonToString.toJson(this._consumableItemKey);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get mapKey() {
    return this._hasMapKey ? this._mapKey : JsonToString.default;
  }
  get hasMapKey() {
    return this._hasMapKey;
  }
  setMapKey(path, value) {
    return {type: 'SET', path: path.concat(['mapKey']), value};
  }
  deleteMapKey(path) {
    return {type: 'DELETE', path: path.concat(['mapKey'])};
  }
  /**
   * @returns {string}
   */
  get challengeMapKey() {
    return this._hasChallengeMapKey ? this._challengeMapKey : JsonToString.default;
  }
  get hasChallengeMapKey() {
    return this._hasChallengeMapKey;
  }
  setChallengeMapKey(path, value) {
    return {type: 'SET', path: path.concat(['challengeMapKey']), value};
  }
  deleteChallengeMapKey(path) {
    return {type: 'DELETE', path: path.concat(['challengeMapKey'])};
  }
  /**
   * @returns {string}
   */
  get newPlayerMapKey() {
    return this._hasNewPlayerMapKey ? this._newPlayerMapKey : JsonToString.default;
  }
  get hasNewPlayerMapKey() {
    return this._hasNewPlayerMapKey;
  }
  setNewPlayerMapKey(path, value) {
    return {type: 'SET', path: path.concat(['newPlayerMapKey']), value};
  }
  deleteNewPlayerMapKey(path) {
    return {type: 'DELETE', path: path.concat(['newPlayerMapKey'])};
  }
  /**
   * @returns {number}
   */
  get requiredLevel() {
    return this._hasRequiredLevel ? this._requiredLevel : JsonToInt32.default;
  }
  get hasRequiredLevel() {
    return this._hasRequiredLevel;
  }
  setRequiredLevel(path, value) {
    return {type: 'SET', path: path.concat(['requiredLevel']), value};
  }
  deleteRequiredLevel(path) {
    return {type: 'DELETE', path: path.concat(['requiredLevel'])};
  }
  /**
   * @returns {boolean}
   */
  get isBossLevel() {
    return this._hasIsBossLevel ? this._isBossLevel : JsonToBoolean.default;
  }
  get hasIsBossLevel() {
    return this._hasIsBossLevel;
  }
  setIsBossLevel(path, value) {
    return {type: 'SET', path: path.concat(['isBossLevel']), value};
  }
  deleteIsBossLevel(path) {
    return {type: 'DELETE', path: path.concat(['isBossLevel'])};
  }
  /**
   * @returns {string}
   */
  get consumableItemKey() {
    return this._hasConsumableItemKey ? this._consumableItemKey : JsonToString.default;
  }
  get hasConsumableItemKey() {
    return this._hasConsumableItemKey;
  }
  setConsumableItemKey(path, value) {
    return {type: 'SET', path: path.concat(['consumableItemKey']), value};
  }
  deleteConsumableItemKey(path) {
    return {type: 'DELETE', path: path.concat(['consumableItemKey'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "mapKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignData_Level(this);
              copy._hasMapKey = true;
              copy._mapKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMapKey) {
                return this;
              }
              const copy = new CampaignData_Level(this);
              copy._hasMapKey = false;
              copy._mapKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "challengeMapKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignData_Level(this);
              copy._hasChallengeMapKey = true;
              copy._challengeMapKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChallengeMapKey) {
                return this;
              }
              const copy = new CampaignData_Level(this);
              copy._hasChallengeMapKey = false;
              copy._challengeMapKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "newPlayerMapKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignData_Level(this);
              copy._hasNewPlayerMapKey = true;
              copy._newPlayerMapKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasNewPlayerMapKey) {
                return this;
              }
              const copy = new CampaignData_Level(this);
              copy._hasNewPlayerMapKey = false;
              copy._newPlayerMapKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "requiredLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignData_Level(this);
              copy._hasRequiredLevel = true;
              copy._requiredLevel = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRequiredLevel) {
                return this;
              }
              const copy = new CampaignData_Level(this);
              copy._hasRequiredLevel = false;
              copy._requiredLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "isBossLevel": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignData_Level(this);
              copy._hasIsBossLevel = true;
              copy._isBossLevel = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIsBossLevel) {
                return this;
              }
              const copy = new CampaignData_Level(this);
              copy._hasIsBossLevel = false;
              copy._isBossLevel = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "consumableItemKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignData_Level(this);
              copy._hasConsumableItemKey = true;
              copy._consumableItemKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasConsumableItemKey) {
                return this;
              }
              const copy = new CampaignData_Level(this);
              copy._hasConsumableItemKey = false;
              copy._consumableItemKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CampaignData_Level} other
   * @returns {CampaignData_Level}
   */
  merge(other) {
    const copy = new CampaignData_Level(this);
    if (other._hasMapKey) {
      copy._hasMapKey = true;
      copy._mapKey = other._mapKey;
    }
    if (other._hasChallengeMapKey) {
      copy._hasChallengeMapKey = true;
      copy._challengeMapKey = other._challengeMapKey;
    }
    if (other._hasNewPlayerMapKey) {
      copy._hasNewPlayerMapKey = true;
      copy._newPlayerMapKey = other._newPlayerMapKey;
    }
    if (other._hasRequiredLevel) {
      copy._hasRequiredLevel = true;
      copy._requiredLevel = other._requiredLevel;
    }
    if (other._hasIsBossLevel) {
      copy._hasIsBossLevel = true;
      copy._isBossLevel = other._isBossLevel;
    }
    if (other._hasConsumableItemKey) {
      copy._hasConsumableItemKey = true;
      copy._consumableItemKey = other._consumableItemKey;
    }
    return copy;
  }
}
CampaignData_Level.default = new CampaignData_Level();
class CampaignData_Level_Builder {
  constructor(value) {
    this._value = new CampaignData_Level(value);
  }
  build() {
    return new CampaignData_Level(this._value);
  }
  setMapKey(value) {
    this._value._hasMapKey = true;
    this._value._mapKey = value;
    return this;
  }
  deleteMapKey() {
    this._value._hasMapKey = false;
    this._value._mapKey = null;
    return this;
  }
  setChallengeMapKey(value) {
    this._value._hasChallengeMapKey = true;
    this._value._challengeMapKey = value;
    return this;
  }
  deleteChallengeMapKey() {
    this._value._hasChallengeMapKey = false;
    this._value._challengeMapKey = null;
    return this;
  }
  setNewPlayerMapKey(value) {
    this._value._hasNewPlayerMapKey = true;
    this._value._newPlayerMapKey = value;
    return this;
  }
  deleteNewPlayerMapKey() {
    this._value._hasNewPlayerMapKey = false;
    this._value._newPlayerMapKey = null;
    return this;
  }
  setRequiredLevel(value) {
    this._value._hasRequiredLevel = true;
    this._value._requiredLevel = value;
    return this;
  }
  deleteRequiredLevel() {
    this._value._hasRequiredLevel = false;
    this._value._requiredLevel = null;
    return this;
  }
  setIsBossLevel(value) {
    this._value._hasIsBossLevel = true;
    this._value._isBossLevel = value;
    return this;
  }
  deleteIsBossLevel() {
    this._value._hasIsBossLevel = false;
    this._value._isBossLevel = null;
    return this;
  }
  setConsumableItemKey(value) {
    this._value._hasConsumableItemKey = true;
    this._value._consumableItemKey = value;
    return this;
  }
  deleteConsumableItemKey() {
    this._value._hasConsumableItemKey = false;
    this._value._consumableItemKey = null;
    return this;
  }
}
CampaignData_Level.Builder = CampaignData_Level_Builder;
class CampaignData_Level_WithParent {
  /**
   * @param {CampaignData_Level} value
   * @param {CampaignData_Level_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CampaignData_Level.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasMapKey() {
    if (this._cachedHasMapKey === undefined) {
      if (this._value.hasMapKey) {
        this._cachedHasMapKey = true;
      } else {
        this._cachedHasMapKey = this._parent ? this._parent.hasMapKey : false;
      }
    }
    return this._cachedHasMapKey;
  }
  get mapKey() {
    if (this._cachedMapKey === undefined) {
      if (this._value.hasMapKey) {
        this._cachedMapKey = this._value.mapKey;
      } else {
        this._cachedMapKey = this._parent ? this._parent.mapKey : this._value.mapKey;
      }
    }
    return this._cachedMapKey;
  }
  get hasChallengeMapKey() {
    if (this._cachedHasChallengeMapKey === undefined) {
      if (this._value.hasChallengeMapKey) {
        this._cachedHasChallengeMapKey = true;
      } else {
        this._cachedHasChallengeMapKey = this._parent ? this._parent.hasChallengeMapKey : false;
      }
    }
    return this._cachedHasChallengeMapKey;
  }
  get challengeMapKey() {
    if (this._cachedChallengeMapKey === undefined) {
      if (this._value.hasChallengeMapKey) {
        this._cachedChallengeMapKey = this._value.challengeMapKey;
      } else {
        this._cachedChallengeMapKey = this._parent ? this._parent.challengeMapKey : this._value.challengeMapKey;
      }
    }
    return this._cachedChallengeMapKey;
  }
  get hasNewPlayerMapKey() {
    if (this._cachedHasNewPlayerMapKey === undefined) {
      if (this._value.hasNewPlayerMapKey) {
        this._cachedHasNewPlayerMapKey = true;
      } else {
        this._cachedHasNewPlayerMapKey = this._parent ? this._parent.hasNewPlayerMapKey : false;
      }
    }
    return this._cachedHasNewPlayerMapKey;
  }
  get newPlayerMapKey() {
    if (this._cachedNewPlayerMapKey === undefined) {
      if (this._value.hasNewPlayerMapKey) {
        this._cachedNewPlayerMapKey = this._value.newPlayerMapKey;
      } else {
        this._cachedNewPlayerMapKey = this._parent ? this._parent.newPlayerMapKey : this._value.newPlayerMapKey;
      }
    }
    return this._cachedNewPlayerMapKey;
  }
  get hasRequiredLevel() {
    if (this._cachedHasRequiredLevel === undefined) {
      if (this._value.hasRequiredLevel) {
        this._cachedHasRequiredLevel = true;
      } else {
        this._cachedHasRequiredLevel = this._parent ? this._parent.hasRequiredLevel : false;
      }
    }
    return this._cachedHasRequiredLevel;
  }
  get requiredLevel() {
    if (this._cachedRequiredLevel === undefined) {
      if (this._value.hasRequiredLevel) {
        this._cachedRequiredLevel = this._value.requiredLevel;
      } else {
        this._cachedRequiredLevel = this._parent ? this._parent.requiredLevel : this._value.requiredLevel;
      }
    }
    return this._cachedRequiredLevel;
  }
  get hasIsBossLevel() {
    if (this._cachedHasIsBossLevel === undefined) {
      if (this._value.hasIsBossLevel) {
        this._cachedHasIsBossLevel = true;
      } else {
        this._cachedHasIsBossLevel = this._parent ? this._parent.hasIsBossLevel : false;
      }
    }
    return this._cachedHasIsBossLevel;
  }
  get isBossLevel() {
    if (this._cachedIsBossLevel === undefined) {
      if (this._value.hasIsBossLevel) {
        this._cachedIsBossLevel = this._value.isBossLevel;
      } else {
        this._cachedIsBossLevel = this._parent ? this._parent.isBossLevel : this._value.isBossLevel;
      }
    }
    return this._cachedIsBossLevel;
  }
  get hasConsumableItemKey() {
    if (this._cachedHasConsumableItemKey === undefined) {
      if (this._value.hasConsumableItemKey) {
        this._cachedHasConsumableItemKey = true;
      } else {
        this._cachedHasConsumableItemKey = this._parent ? this._parent.hasConsumableItemKey : false;
      }
    }
    return this._cachedHasConsumableItemKey;
  }
  get consumableItemKey() {
    if (this._cachedConsumableItemKey === undefined) {
      if (this._value.hasConsumableItemKey) {
        this._cachedConsumableItemKey = this._value.consumableItemKey;
      } else {
        this._cachedConsumableItemKey = this._parent ? this._parent.consumableItemKey : this._value.consumableItemKey;
      }
    }
    return this._cachedConsumableItemKey;
  }
  update(current, parent) {
    const result = new CampaignData_Level_WithParent(current, parent);
    return result;
  }
}
CampaignData_Level_WithParent.default = new CampaignData_Level_WithParent(CampaignData_Level.default, null);
CampaignData_Level.WithParent = CampaignData_Level_WithParent;
class CampaignData_Level_Descriptor {
  get mapKey() {
    if (!this._mapKey) {
      this._mapKey = {
        name: "mapKey",
        Name: "MapKey",
        number: 8,
        protoType: 9,
        protoName: "map_key",
        type: JsonToString,
        options: {
          valueDropdown: "MapKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mapKey;
  }
  get challengeMapKey() {
    if (!this._challengeMapKey) {
      this._challengeMapKey = {
        name: "challengeMapKey",
        Name: "ChallengeMapKey",
        number: 11,
        protoType: 9,
        protoName: "challenge_map_key",
        type: JsonToString,
        options: {
          valueDropdown: "MapKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._challengeMapKey;
  }
  get newPlayerMapKey() {
    if (!this._newPlayerMapKey) {
      this._newPlayerMapKey = {
        name: "newPlayerMapKey",
        Name: "NewPlayerMapKey",
        number: 13,
        protoType: 9,
        protoName: "new_player_map_key",
        type: JsonToString,
        options: {
          valueDropdown: "MapKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._newPlayerMapKey;
  }
  get requiredLevel() {
    if (!this._requiredLevel) {
      this._requiredLevel = {
        name: "requiredLevel",
        Name: "RequiredLevel",
        number: 4,
        protoType: 5,
        protoName: "required_level",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._requiredLevel;
  }
  get isBossLevel() {
    if (!this._isBossLevel) {
      this._isBossLevel = {
        name: "isBossLevel",
        Name: "IsBossLevel",
        number: 9,
        protoType: 8,
        protoName: "is_boss_level",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._isBossLevel;
  }
  get consumableItemKey() {
    if (!this._consumableItemKey) {
      this._consumableItemKey = {
        name: "consumableItemKey",
        Name: "ConsumableItemKey",
        number: 10,
        protoType: 9,
        protoName: "consumable_item_key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._consumableItemKey;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.mapKey,
        this.challengeMapKey,
        this.newPlayerMapKey,
        this.requiredLevel,
        this.isBossLevel,
        this.consumableItemKey,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForMapKey",
        Name: "DummyOneofForMapKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChallengeMapKey",
        Name: "DummyOneofForChallengeMapKey",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForNewPlayerMapKey",
        Name: "DummyOneofForNewPlayerMapKey",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRequiredLevel",
        Name: "DummyOneofForRequiredLevel",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIsBossLevel",
        Name: "DummyOneofForIsBossLevel",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForConsumableItemKey",
        Name: "DummyOneofForConsumableItemKey",
        fields: [
          this.fields[5],
        ],
      });
    }
    return this._oneofs;
  }
}
CampaignData_Level.descriptor = new CampaignData_Level_Descriptor();
class CampaignData_World {
  get descriptor() {
    return CampaignData_World.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPath = false;
    this._path = null;
    this._hasDisplayName = false;
    this._displayName = null;
    this._levels = [];
  }
  isEmpty() {
    if (this._hasPath) return false;
    if (this._hasDisplayName) return false;
    if (this._levels.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CampaignData_World) {
      return value;
    }
    return CampaignData_World.fromJson(value);
  }
  static fromJson(json) {
    const result = new CampaignData_World();
    if (json.path != null) {
      result._hasPath = true;
      result._path = JsonToString.fromJson(json.path);
    }
    if (json.displayName != null) {
      result._hasDisplayName = true;
      result._displayName = JsonToString.fromJson(json.displayName);
    }
    result._levels = JsonToList(json.levels, CampaignData_Level);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPath) {
      result.path = JsonToString.toJson(this._path);
    }
    if (this._hasDisplayName) {
      result.displayName = JsonToString.toJson(this._displayName);
    }
    if (this._levels.length > 0) {
      result.levels = ArrayToJson(this._levels, CampaignData_Level);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get path() {
    return this._hasPath ? this._path : JsonToString.default;
  }
  get hasPath() {
    return this._hasPath;
  }
  setPath(path, value) {
    return {type: 'SET', path: path.concat(['path']), value};
  }
  deletePath(path) {
    return {type: 'DELETE', path: path.concat(['path'])};
  }
  /**
   * @returns {string}
   */
  get displayName() {
    return this._hasDisplayName ? this._displayName : JsonToString.default;
  }
  get hasDisplayName() {
    return this._hasDisplayName;
  }
  setDisplayName(path, value) {
    return {type: 'SET', path: path.concat(['displayName']), value};
  }
  deleteDisplayName(path) {
    return {type: 'DELETE', path: path.concat(['displayName'])};
  }
  /**
   * @returns {CampaignData_Level[]}
   */
  get levels() {
    return this._levels;
  }
  addLevels(path, value) {
    return {type: 'ADD', path: path.concat(['levels']), value: value.toJson()};
  }
  setLevels(path, value) {
    return {type: 'SET', path: path.concat(['levels']), value: ArrayToJson(value, CampaignData_Level)};
  }
  setLevelsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['levels', key]), value: value.toJson()};
  }
  deleteLevels(path) {
    return {type: 'DELETE', path: path.concat(['levels'])};
  }
  deleteLevelsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['levels', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "path": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignData_World(this);
              copy._hasPath = true;
              copy._path = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPath) {
                return this;
              }
              const copy = new CampaignData_World(this);
              copy._hasPath = false;
              copy._path = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "displayName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignData_World(this);
              copy._hasDisplayName = true;
              copy._displayName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisplayName) {
                return this;
              }
              const copy = new CampaignData_World(this);
              copy._hasDisplayName = false;
              copy._displayName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "levels": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignData_World(this);
              copy._levels = [];        for (let i of value) {
                copy._levels.push(CampaignData_Level.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CampaignData_World(this);
              copy._levels = copy._levels.concat([CampaignData_Level.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._levels.length === 0) {
                return this;
              }
              const copy = new CampaignData_World(this);
              copy._levels = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._levels.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CampaignData_World(this);
              copy._levels = copy._levels.slice();
              copy._levels[path[1]] = CampaignData_Level.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CampaignData_World(this);
              copy._levels = copy._levels.slice(0, path[1]).concat(copy._levels.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._levels.length) {
            return this;
          }
          const oldValue = this._levels[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CampaignData_World(this);
          copy._levels = copy._levels.slice();
          copy._levels[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CampaignData_World} other
   * @returns {CampaignData_World}
   */
  merge(other) {
    const copy = new CampaignData_World(this);
    if (other._hasPath) {
      copy._hasPath = true;
      copy._path = other._path;
    }
    if (other._hasDisplayName) {
      copy._hasDisplayName = true;
      copy._displayName = other._displayName;
    }
    copy._levels = this._levels.concat(other._levels);
    return copy;
  }
}
CampaignData_World.default = new CampaignData_World();
class CampaignData_World_Builder {
  constructor(value) {
    this._value = new CampaignData_World(value);
  }
  build() {
    return new CampaignData_World(this._value);
  }
  setPath(value) {
    this._value._hasPath = true;
    this._value._path = value;
    return this;
  }
  deletePath() {
    this._value._hasPath = false;
    this._value._path = null;
    return this;
  }
  setDisplayName(value) {
    this._value._hasDisplayName = true;
    this._value._displayName = value;
    return this;
  }
  deleteDisplayName() {
    this._value._hasDisplayName = false;
    this._value._displayName = null;
    return this;
  }
  addAllLevels(values) {
    this._value._levels = this._value._levels.concat(values);
    return this;
  }
  addLevels(value) {
    this._value._levels = this._value._levels.concat([value]);
    return this;
  }
  setLevels(index, value) {
    this._value._levels = this._value._levels.concat();
    this._value._levels[index] = value;
    return this;
  }
  clearLevels() {
    this._value._levels = [];
    return this;
  }
}
CampaignData_World.Builder = CampaignData_World_Builder;
class CampaignData_World_WithParent {
  /**
   * @param {CampaignData_World} value
   * @param {CampaignData_World_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CampaignData_World.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPath() {
    if (this._cachedHasPath === undefined) {
      if (this._value.hasPath) {
        this._cachedHasPath = true;
      } else {
        this._cachedHasPath = this._parent ? this._parent.hasPath : false;
      }
    }
    return this._cachedHasPath;
  }
  get path() {
    if (this._cachedPath === undefined) {
      if (this._value.hasPath) {
        this._cachedPath = this._value.path;
      } else {
        this._cachedPath = this._parent ? this._parent.path : this._value.path;
      }
    }
    return this._cachedPath;
  }
  get hasDisplayName() {
    if (this._cachedHasDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedHasDisplayName = true;
      } else {
        this._cachedHasDisplayName = this._parent ? this._parent.hasDisplayName : false;
      }
    }
    return this._cachedHasDisplayName;
  }
  get displayName() {
    if (this._cachedDisplayName === undefined) {
      if (this._value.hasDisplayName) {
        this._cachedDisplayName = this._value.displayName;
      } else {
        this._cachedDisplayName = this._parent ? this._parent.displayName : this._value.displayName;
      }
    }
    return this._cachedDisplayName;
  }
  get selfLevels() {
    if (!this._selfLevels) {
      this._selfLevels = [];
      for (let i of this._value.levels) {
        this._selfLevels.push(new CampaignData_Level.WithParent(i, null));
      }
    }
    return this._selfLevels;
  }
  get inherentLevels() {
    if (!this._inherentLevels) {
      this._inherentLevels = this._parent ? this._parent.levels : [];
    }
    return this._inherentLevels;
  }
  get levels() {
    if (!this._allLevels) {
      this._allLevels = this._parent ? this._parent.levels.concat(this.selfLevels) : this.selfLevels;
    }
    return this._allLevels;
  }
  update(current, parent) {
    const result = new CampaignData_World_WithParent(current, parent);
    if (this._selfLevels) {
      if (this._value.levels === current.levels) {
        result._selfLevels = this._selfLevels;
      } else {
        result._selfLevels = [];
        for (let i = 0; i < current.levels.length; i++) {
          const oldValue = this._value.levels[i];
          if (oldValue) {
            const oldCache = this._selfLevels[i];
            if (oldValue === current.levels[i]) {
              result._selfLevels[i] = oldCache;
            } else {
              result._selfLevels[i] = oldCache.update(current.levels[i], null);
            }
          } else {
            result._selfLevels[i] = new CampaignData_Level.WithParent(current.levels[i], null);
          }
        }
      }
    }
    return result;
  }
}
CampaignData_World_WithParent.default = new CampaignData_World_WithParent(CampaignData_World.default, null);
CampaignData_World.WithParent = CampaignData_World_WithParent;
class CampaignData_World_Descriptor {
  get path() {
    if (!this._path) {
      this._path = {
        name: "path",
        Name: "Path",
        number: 1,
        protoType: 9,
        protoName: "path",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._path;
  }
  get displayName() {
    if (!this._displayName) {
      this._displayName = {
        name: "displayName",
        Name: "DisplayName",
        number: 2,
        protoType: 9,
        protoName: "display_name",
        type: JsonToString,
        options: {
          localization: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._displayName;
  }
  get levels() {
    if (!this._levels) {
      this._levels = {
        name: "levels",
        Name: "Levels",
        number: 4,
        protoType: 11,
        protoName: "levels",
        type: CampaignData_Level,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._levels;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.path,
        this.displayName,
        this.levels,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPath",
        Name: "DummyOneofForPath",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisplayName",
        Name: "DummyOneofForDisplayName",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
CampaignData_World.descriptor = new CampaignData_World_Descriptor();
class CampaignData_CampaignMilestonePath_Milestone {
  get descriptor() {
    return CampaignData_CampaignMilestonePath_Milestone.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._hasRequiredPerfectCount = false;
    this._requiredPerfectCount = null;
    this._rewards = [];
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._hasRequiredPerfectCount) return false;
    if (this._rewards.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CampaignData_CampaignMilestonePath_Milestone) {
      return value;
    }
    return CampaignData_CampaignMilestonePath_Milestone.fromJson(value);
  }
  static fromJson(json) {
    const result = new CampaignData_CampaignMilestonePath_Milestone();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    if (json.requiredPerfectCount != null) {
      result._hasRequiredPerfectCount = true;
      result._requiredPerfectCount = JsonToInt32.fromJson(json.requiredPerfectCount);
    }
    result._rewards = JsonToList(json.rewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._hasRequiredPerfectCount) {
      result.requiredPerfectCount = JsonToInt32.toJson(this._requiredPerfectCount);
    }
    if (this._rewards.length > 0) {
      result.rewards = ArrayToJson(this._rewards, dcei_wildsky_common_proto.InventoryItemKeyValuePair);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {number}
   */
  get requiredPerfectCount() {
    return this._hasRequiredPerfectCount ? this._requiredPerfectCount : JsonToInt32.default;
  }
  get hasRequiredPerfectCount() {
    return this._hasRequiredPerfectCount;
  }
  setRequiredPerfectCount(path, value) {
    return {type: 'SET', path: path.concat(['requiredPerfectCount']), value};
  }
  deleteRequiredPerfectCount(path) {
    return {type: 'DELETE', path: path.concat(['requiredPerfectCount'])};
  }
  /**
   * @returns {dcei_wildsky_common_proto.InventoryItemKeyValuePair[]}
   */
  get rewards() {
    return this._rewards;
  }
  addRewards(path, value) {
    return {type: 'ADD', path: path.concat(['rewards']), value: value.toJson()};
  }
  setRewards(path, value) {
    return {type: 'SET', path: path.concat(['rewards']), value: ArrayToJson(value, dcei_wildsky_common_proto.InventoryItemKeyValuePair)};
  }
  setRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewards', key]), value: value.toJson()};
  }
  deleteRewards(path) {
    return {type: 'DELETE', path: path.concat(['rewards'])};
  }
  deleteRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewards', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignData_CampaignMilestonePath_Milestone(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new CampaignData_CampaignMilestonePath_Milestone(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "requiredPerfectCount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignData_CampaignMilestonePath_Milestone(this);
              copy._hasRequiredPerfectCount = true;
              copy._requiredPerfectCount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRequiredPerfectCount) {
                return this;
              }
              const copy = new CampaignData_CampaignMilestonePath_Milestone(this);
              copy._hasRequiredPerfectCount = false;
              copy._requiredPerfectCount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignData_CampaignMilestonePath_Milestone(this);
              copy._rewards = [];        for (let i of value) {
                copy._rewards.push(dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CampaignData_CampaignMilestonePath_Milestone(this);
              copy._rewards = copy._rewards.concat([dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewards.length === 0) {
                return this;
              }
              const copy = new CampaignData_CampaignMilestonePath_Milestone(this);
              copy._rewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CampaignData_CampaignMilestonePath_Milestone(this);
              copy._rewards = copy._rewards.slice();
              copy._rewards[path[1]] = dcei_wildsky_common_proto.InventoryItemKeyValuePair.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CampaignData_CampaignMilestonePath_Milestone(this);
              copy._rewards = copy._rewards.slice(0, path[1]).concat(copy._rewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          const oldValue = this._rewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CampaignData_CampaignMilestonePath_Milestone(this);
          copy._rewards = copy._rewards.slice();
          copy._rewards[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CampaignData_CampaignMilestonePath_Milestone} other
   * @returns {CampaignData_CampaignMilestonePath_Milestone}
   */
  merge(other) {
    const copy = new CampaignData_CampaignMilestonePath_Milestone(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    if (other._hasRequiredPerfectCount) {
      copy._hasRequiredPerfectCount = true;
      copy._requiredPerfectCount = other._requiredPerfectCount;
    }
    copy._rewards = this._rewards.concat(other._rewards);
    return copy;
  }
}
CampaignData_CampaignMilestonePath_Milestone.default = new CampaignData_CampaignMilestonePath_Milestone();
class CampaignData_CampaignMilestonePath_Milestone_Builder {
  constructor(value) {
    this._value = new CampaignData_CampaignMilestonePath_Milestone(value);
  }
  build() {
    return new CampaignData_CampaignMilestonePath_Milestone(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  setRequiredPerfectCount(value) {
    this._value._hasRequiredPerfectCount = true;
    this._value._requiredPerfectCount = value;
    return this;
  }
  deleteRequiredPerfectCount() {
    this._value._hasRequiredPerfectCount = false;
    this._value._requiredPerfectCount = null;
    return this;
  }
  addAllRewards(values) {
    this._value._rewards = this._value._rewards.concat(values);
    return this;
  }
  addRewards(value) {
    this._value._rewards = this._value._rewards.concat([value]);
    return this;
  }
  setRewards(index, value) {
    this._value._rewards = this._value._rewards.concat();
    this._value._rewards[index] = value;
    return this;
  }
  clearRewards() {
    this._value._rewards = [];
    return this;
  }
}
CampaignData_CampaignMilestonePath_Milestone.Builder = CampaignData_CampaignMilestonePath_Milestone_Builder;
class CampaignData_CampaignMilestonePath_Milestone_WithParent {
  /**
   * @param {CampaignData_CampaignMilestonePath_Milestone} value
   * @param {CampaignData_CampaignMilestonePath_Milestone_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CampaignData_CampaignMilestonePath_Milestone.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get hasRequiredPerfectCount() {
    if (this._cachedHasRequiredPerfectCount === undefined) {
      if (this._value.hasRequiredPerfectCount) {
        this._cachedHasRequiredPerfectCount = true;
      } else {
        this._cachedHasRequiredPerfectCount = this._parent ? this._parent.hasRequiredPerfectCount : false;
      }
    }
    return this._cachedHasRequiredPerfectCount;
  }
  get requiredPerfectCount() {
    if (this._cachedRequiredPerfectCount === undefined) {
      if (this._value.hasRequiredPerfectCount) {
        this._cachedRequiredPerfectCount = this._value.requiredPerfectCount;
      } else {
        this._cachedRequiredPerfectCount = this._parent ? this._parent.requiredPerfectCount : this._value.requiredPerfectCount;
      }
    }
    return this._cachedRequiredPerfectCount;
  }
  get selfRewards() {
    if (!this._selfRewards) {
      this._selfRewards = [];
      for (let i of this._value.rewards) {
        this._selfRewards.push(new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(i, null));
      }
    }
    return this._selfRewards;
  }
  get inherentRewards() {
    if (!this._inherentRewards) {
      this._inherentRewards = this._parent ? this._parent.rewards : [];
    }
    return this._inherentRewards;
  }
  get rewards() {
    if (!this._allRewards) {
      this._allRewards = this._parent ? this._parent.rewards.concat(this.selfRewards) : this.selfRewards;
    }
    return this._allRewards;
  }
  update(current, parent) {
    const result = new CampaignData_CampaignMilestonePath_Milestone_WithParent(current, parent);
    if (this._selfRewards) {
      if (this._value.rewards === current.rewards) {
        result._selfRewards = this._selfRewards;
      } else {
        result._selfRewards = [];
        for (let i = 0; i < current.rewards.length; i++) {
          const oldValue = this._value.rewards[i];
          if (oldValue) {
            const oldCache = this._selfRewards[i];
            if (oldValue === current.rewards[i]) {
              result._selfRewards[i] = oldCache;
            } else {
              result._selfRewards[i] = oldCache.update(current.rewards[i], null);
            }
          } else {
            result._selfRewards[i] = new dcei_wildsky_common_proto.InventoryItemKeyValuePair.WithParent(current.rewards[i], null);
          }
        }
      }
    }
    return result;
  }
}
CampaignData_CampaignMilestonePath_Milestone_WithParent.default = new CampaignData_CampaignMilestonePath_Milestone_WithParent(CampaignData_CampaignMilestonePath_Milestone.default, null);
CampaignData_CampaignMilestonePath_Milestone.WithParent = CampaignData_CampaignMilestonePath_Milestone_WithParent;
class CampaignData_CampaignMilestonePath_Milestone_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get requiredPerfectCount() {
    if (!this._requiredPerfectCount) {
      this._requiredPerfectCount = {
        name: "requiredPerfectCount",
        Name: "RequiredPerfectCount",
        number: 2,
        protoType: 5,
        protoName: "required_perfect_count",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._requiredPerfectCount;
  }
  get rewards() {
    if (!this._rewards) {
      this._rewards = {
        name: "rewards",
        Name: "Rewards",
        number: 3,
        protoType: 11,
        protoName: "rewards",
        type: dcei_wildsky_common_proto.InventoryItemKeyValuePair,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewards;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.requiredPerfectCount,
        this.rewards,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRequiredPerfectCount",
        Name: "DummyOneofForRequiredPerfectCount",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
CampaignData_CampaignMilestonePath_Milestone.descriptor = new CampaignData_CampaignMilestonePath_Milestone_Descriptor();
class CampaignData_CampaignMilestonePath {
  get descriptor() {
    return CampaignData_CampaignMilestonePath.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._milestones = [];
  }
  isEmpty() {
    if (this._milestones.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CampaignData_CampaignMilestonePath) {
      return value;
    }
    return CampaignData_CampaignMilestonePath.fromJson(value);
  }
  static fromJson(json) {
    const result = new CampaignData_CampaignMilestonePath();
    result._milestones = JsonToList(json.milestones, CampaignData_CampaignMilestonePath_Milestone);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._milestones.length > 0) {
      result.milestones = ArrayToJson(this._milestones, CampaignData_CampaignMilestonePath_Milestone);
    }
    return result;
  }
  /**
   * @returns {CampaignData_CampaignMilestonePath_Milestone[]}
   */
  get milestones() {
    return this._milestones;
  }
  addMilestones(path, value) {
    return {type: 'ADD', path: path.concat(['milestones']), value: value.toJson()};
  }
  setMilestones(path, value) {
    return {type: 'SET', path: path.concat(['milestones']), value: ArrayToJson(value, CampaignData_CampaignMilestonePath_Milestone)};
  }
  setMilestonesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['milestones', key]), value: value.toJson()};
  }
  deleteMilestones(path) {
    return {type: 'DELETE', path: path.concat(['milestones'])};
  }
  deleteMilestonesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['milestones', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "milestones": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignData_CampaignMilestonePath(this);
              copy._milestones = [];        for (let i of value) {
                copy._milestones.push(CampaignData_CampaignMilestonePath_Milestone.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CampaignData_CampaignMilestonePath(this);
              copy._milestones = copy._milestones.concat([CampaignData_CampaignMilestonePath_Milestone.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._milestones.length === 0) {
                return this;
              }
              const copy = new CampaignData_CampaignMilestonePath(this);
              copy._milestones = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._milestones.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CampaignData_CampaignMilestonePath(this);
              copy._milestones = copy._milestones.slice();
              copy._milestones[path[1]] = CampaignData_CampaignMilestonePath_Milestone.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CampaignData_CampaignMilestonePath(this);
              copy._milestones = copy._milestones.slice(0, path[1]).concat(copy._milestones.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._milestones.length) {
            return this;
          }
          const oldValue = this._milestones[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CampaignData_CampaignMilestonePath(this);
          copy._milestones = copy._milestones.slice();
          copy._milestones[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CampaignData_CampaignMilestonePath} other
   * @returns {CampaignData_CampaignMilestonePath}
   */
  merge(other) {
    const copy = new CampaignData_CampaignMilestonePath(this);
    copy._milestones = this._milestones.concat(other._milestones);
    return copy;
  }
}
CampaignData_CampaignMilestonePath.default = new CampaignData_CampaignMilestonePath();
CampaignData_CampaignMilestonePath.Milestone = CampaignData_CampaignMilestonePath_Milestone;
class CampaignData_CampaignMilestonePath_Builder {
  constructor(value) {
    this._value = new CampaignData_CampaignMilestonePath(value);
  }
  build() {
    return new CampaignData_CampaignMilestonePath(this._value);
  }
  addAllMilestones(values) {
    this._value._milestones = this._value._milestones.concat(values);
    return this;
  }
  addMilestones(value) {
    this._value._milestones = this._value._milestones.concat([value]);
    return this;
  }
  setMilestones(index, value) {
    this._value._milestones = this._value._milestones.concat();
    this._value._milestones[index] = value;
    return this;
  }
  clearMilestones() {
    this._value._milestones = [];
    return this;
  }
}
CampaignData_CampaignMilestonePath.Builder = CampaignData_CampaignMilestonePath_Builder;
class CampaignData_CampaignMilestonePath_WithParent {
  /**
   * @param {CampaignData_CampaignMilestonePath} value
   * @param {CampaignData_CampaignMilestonePath_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CampaignData_CampaignMilestonePath.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfMilestones() {
    if (!this._selfMilestones) {
      this._selfMilestones = [];
      for (let i of this._value.milestones) {
        this._selfMilestones.push(new CampaignData_CampaignMilestonePath_Milestone.WithParent(i, null));
      }
    }
    return this._selfMilestones;
  }
  get inherentMilestones() {
    if (!this._inherentMilestones) {
      this._inherentMilestones = this._parent ? this._parent.milestones : [];
    }
    return this._inherentMilestones;
  }
  get milestones() {
    if (!this._allMilestones) {
      this._allMilestones = this._parent ? this._parent.milestones.concat(this.selfMilestones) : this.selfMilestones;
    }
    return this._allMilestones;
  }
  update(current, parent) {
    const result = new CampaignData_CampaignMilestonePath_WithParent(current, parent);
    if (this._selfMilestones) {
      if (this._value.milestones === current.milestones) {
        result._selfMilestones = this._selfMilestones;
      } else {
        result._selfMilestones = [];
        for (let i = 0; i < current.milestones.length; i++) {
          const oldValue = this._value.milestones[i];
          if (oldValue) {
            const oldCache = this._selfMilestones[i];
            if (oldValue === current.milestones[i]) {
              result._selfMilestones[i] = oldCache;
            } else {
              result._selfMilestones[i] = oldCache.update(current.milestones[i], null);
            }
          } else {
            result._selfMilestones[i] = new CampaignData_CampaignMilestonePath_Milestone.WithParent(current.milestones[i], null);
          }
        }
      }
    }
    return result;
  }
}
CampaignData_CampaignMilestonePath_WithParent.default = new CampaignData_CampaignMilestonePath_WithParent(CampaignData_CampaignMilestonePath.default, null);
CampaignData_CampaignMilestonePath.WithParent = CampaignData_CampaignMilestonePath_WithParent;
class CampaignData_CampaignMilestonePath_Descriptor {
  get milestones() {
    if (!this._milestones) {
      this._milestones = {
        name: "milestones",
        Name: "Milestones",
        number: 1,
        protoType: 11,
        protoName: "milestones",
        type: CampaignData_CampaignMilestonePath_Milestone,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._milestones;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.milestones,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
CampaignData_CampaignMilestonePath.descriptor = new CampaignData_CampaignMilestonePath_Descriptor();
export class CampaignData {
  get descriptor() {
    return CampaignData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._worlds = [];
    this._hasCampaignMilestonePath = false;
    this._campaignMilestonePath = null;
  }
  isEmpty() {
    if (this._worlds.length > 0) return false;
    if (this._hasCampaignMilestonePath && !this._campaignMilestonePath.isEmpty()) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CampaignData) {
      return value;
    }
    return CampaignData.fromJson(value);
  }
  static fromJson(json) {
    const result = new CampaignData();
    result._worlds = JsonToList(json.worlds, CampaignData_World);
    if (json.campaignMilestonePath != null) {
      result._hasCampaignMilestonePath = true;
      result._campaignMilestonePath = CampaignData_CampaignMilestonePath.fromJson(json.campaignMilestonePath);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._worlds.length > 0) {
      result.worlds = ArrayToJson(this._worlds, CampaignData_World);
    }
    if (this._hasCampaignMilestonePath && !this._campaignMilestonePath.isEmpty()) {
      result.campaignMilestonePath = CampaignData_CampaignMilestonePath.toJson(this._campaignMilestonePath);
    }
    return result;
  }
  /**
   * @returns {CampaignData_World[]}
   */
  get worlds() {
    return this._worlds;
  }
  addWorlds(path, value) {
    return {type: 'ADD', path: path.concat(['worlds']), value: value.toJson()};
  }
  setWorlds(path, value) {
    return {type: 'SET', path: path.concat(['worlds']), value: ArrayToJson(value, CampaignData_World)};
  }
  setWorldsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['worlds', key]), value: value.toJson()};
  }
  deleteWorlds(path) {
    return {type: 'DELETE', path: path.concat(['worlds'])};
  }
  deleteWorldsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['worlds', key])};
  }
  /**
   * @returns {CampaignData_CampaignMilestonePath}
   */
  get campaignMilestonePath() {
    return this._hasCampaignMilestonePath ? this._campaignMilestonePath : CampaignData_CampaignMilestonePath.default;
  }
  get hasCampaignMilestonePath() {
    return this._hasCampaignMilestonePath;
  }
  setCampaignMilestonePath(path, value) {
    return {type: 'SET', path: path.concat(['campaignMilestonePath']), value: value.toJson()};
  }
  deleteCampaignMilestonePath(path) {
    return {type: 'DELETE', path: path.concat(['campaignMilestonePath'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "worlds": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignData(this);
              copy._worlds = [];        for (let i of value) {
                copy._worlds.push(CampaignData_World.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CampaignData(this);
              copy._worlds = copy._worlds.concat([CampaignData_World.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._worlds.length === 0) {
                return this;
              }
              const copy = new CampaignData(this);
              copy._worlds = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._worlds.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CampaignData(this);
              copy._worlds = copy._worlds.slice();
              copy._worlds[path[1]] = CampaignData_World.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CampaignData(this);
              copy._worlds = copy._worlds.slice(0, path[1]).concat(copy._worlds.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._worlds.length) {
            return this;
          }
          const oldValue = this._worlds[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CampaignData(this);
          copy._worlds = copy._worlds.slice();
          copy._worlds[key] = newValue;
          return copy;
        }
      }
      case "campaignMilestonePath": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignData(this);
              copy._hasCampaignMilestonePath = true;
              copy._campaignMilestonePath = CampaignData_CampaignMilestonePath.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCampaignMilestonePath) {
                return this;
              }
              const copy = new CampaignData(this);
              copy._hasCampaignMilestonePath = false;
              copy._campaignMilestonePath = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCampaignMilestonePath) {
            const copy = new CampaignData(this);
            copy._hasCampaignMilestonePath = true;
            copy._campaignMilestonePath = CampaignData_CampaignMilestonePath.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._campaignMilestonePath.apply(type, path.slice(1), value);
          if (newValue === this._campaignMilestonePath) {
            return this;
          }
          const copy = new CampaignData(this);
          copy._campaignMilestonePath = copy._campaignMilestonePath.apply(type, path.slice(1), value);
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CampaignData} other
   * @returns {CampaignData}
   */
  merge(other) {
    const copy = new CampaignData(this);
    copy._worlds = this._worlds.concat(other._worlds);
    if (other._hasCampaignMilestonePath) {
      if (copy._hasCampaignMilestonePath) {
        copy._campaignMilestonePath = copy.campaignMilestonePath.merge(other.campaignMilestonePath);
      } else {
        copy._campaignMilestonePath = other._campaignMilestonePath;
      }
      copy._hasCampaignMilestonePath = true;
    }
    return copy;
  }
}
CampaignData.default = new CampaignData();
CampaignData.Level = CampaignData_Level;
CampaignData.World = CampaignData_World;
CampaignData.CampaignMilestonePath = CampaignData_CampaignMilestonePath;
class CampaignData_Builder {
  constructor(value) {
    this._value = new CampaignData(value);
  }
  build() {
    return new CampaignData(this._value);
  }
  addAllWorlds(values) {
    this._value._worlds = this._value._worlds.concat(values);
    return this;
  }
  addWorlds(value) {
    this._value._worlds = this._value._worlds.concat([value]);
    return this;
  }
  setWorlds(index, value) {
    this._value._worlds = this._value._worlds.concat();
    this._value._worlds[index] = value;
    return this;
  }
  clearWorlds() {
    this._value._worlds = [];
    return this;
  }
  setCampaignMilestonePath(value) {
    this._value._hasCampaignMilestonePath = true;
    this._value._campaignMilestonePath = value;
    return this;
  }
  deleteCampaignMilestonePath() {
    this._value._hasCampaignMilestonePath = false;
    this._value._campaignMilestonePath = null;
    return this;
  }
}
CampaignData.Builder = CampaignData_Builder;
class CampaignData_WithParent {
  /**
   * @param {CampaignData} value
   * @param {CampaignData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CampaignData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfWorlds() {
    if (!this._selfWorlds) {
      this._selfWorlds = [];
      for (let i of this._value.worlds) {
        this._selfWorlds.push(new CampaignData_World.WithParent(i, null));
      }
    }
    return this._selfWorlds;
  }
  get inherentWorlds() {
    if (!this._inherentWorlds) {
      this._inherentWorlds = this._parent ? this._parent.worlds : [];
    }
    return this._inherentWorlds;
  }
  get worlds() {
    if (!this._allWorlds) {
      this._allWorlds = this._parent ? this._parent.worlds.concat(this.selfWorlds) : this.selfWorlds;
    }
    return this._allWorlds;
  }
  get hasCampaignMilestonePath() {
    if (this._cachedHasCampaignMilestonePath === undefined) {
      if (this._value.hasCampaignMilestonePath) {
        this._cachedHasCampaignMilestonePath = true;
      } else {
        this._cachedHasCampaignMilestonePath = this._parent ? this._parent.hasCampaignMilestonePath : false;
      }
    }
    return this._cachedHasCampaignMilestonePath;
  }
  get campaignMilestonePath() {
    if (!this._cachedCampaignMilestonePath) {
      if (this._value.hasCampaignMilestonePath) {
        this._cachedCampaignMilestonePath = new CampaignData_CampaignMilestonePath.WithParent(this._value.campaignMilestonePath, this._parent && this._parent.hasCampaignMilestonePath ? this._parent.campaignMilestonePath : null);
      } else {
        this._cachedCampaignMilestonePath = this._parent ? new CampaignData_CampaignMilestonePath.WithParent(CampaignData_CampaignMilestonePath.default, this._parent.campaignMilestonePath) : CampaignData_CampaignMilestonePath.WithParent.default;
      }
    }
    return this._cachedCampaignMilestonePath;
  }
  update(current, parent) {
    const result = new CampaignData_WithParent(current, parent);
    if (this._selfWorlds) {
      if (this._value.worlds === current.worlds) {
        result._selfWorlds = this._selfWorlds;
      } else {
        result._selfWorlds = [];
        for (let i = 0; i < current.worlds.length; i++) {
          const oldValue = this._value.worlds[i];
          if (oldValue) {
            const oldCache = this._selfWorlds[i];
            if (oldValue === current.worlds[i]) {
              result._selfWorlds[i] = oldCache;
            } else {
              result._selfWorlds[i] = oldCache.update(current.worlds[i], null);
            }
          } else {
            result._selfWorlds[i] = new CampaignData_World.WithParent(current.worlds[i], null);
          }
        }
      }
    }
    if (this._cachedCampaignMilestonePath && this._value.hasCampaignMilestonePath && current.hasCampaignMilestonePath) {
      if (this._value.campaignMilestonePath === current.campaignMilestonePath && this._parent === parent) {
        result._cachedCampaignMilestonePath = this._cachedCampaignMilestonePath;
      } else {
        result._cachedCampaignMilestonePath = this._cachedCampaignMilestonePath.update(current.campaignMilestonePath, parent && parent.hasCampaignMilestonePath ? parent.campaignMilestonePath : null);
      }
    }
    return result;
  }
}
CampaignData_WithParent.default = new CampaignData_WithParent(CampaignData.default, null);
CampaignData.WithParent = CampaignData_WithParent;
class CampaignData_Descriptor {
  get worlds() {
    if (!this._worlds) {
      this._worlds = {
        name: "worlds",
        Name: "Worlds",
        number: 1,
        protoType: 11,
        protoName: "worlds",
        type: CampaignData_World,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._worlds;
  }
  get campaignMilestonePath() {
    if (!this._campaignMilestonePath) {
      this._campaignMilestonePath = {
        name: "campaignMilestonePath",
        Name: "CampaignMilestonePath",
        number: 2,
        protoType: 11,
        protoName: "campaign_milestone_path",
        type: CampaignData_CampaignMilestonePath,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._campaignMilestonePath;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.worlds,
        this.campaignMilestonePath,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForCampaignMilestonePath",
        Name: "DummyOneofForCampaignMilestonePath",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
CampaignData.descriptor = new CampaignData_Descriptor();
class CampaignRewardData_LevelReward {
  get descriptor() {
    return CampaignRewardData_LevelReward.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasItemKey = false;
    this._itemKey = null;
    this._hasAmount = false;
    this._amount = null;
  }
  isEmpty() {
    if (this._hasItemKey) return false;
    if (this._hasAmount) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CampaignRewardData_LevelReward) {
      return value;
    }
    return CampaignRewardData_LevelReward.fromJson(value);
  }
  static fromJson(json) {
    const result = new CampaignRewardData_LevelReward();
    if (json.itemKey != null) {
      result._hasItemKey = true;
      result._itemKey = JsonToString.fromJson(json.itemKey);
    }
    if (json.amount != null) {
      result._hasAmount = true;
      result._amount = JsonToInt32.fromJson(json.amount);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasItemKey) {
      result.itemKey = JsonToString.toJson(this._itemKey);
    }
    if (this._hasAmount) {
      result.amount = JsonToInt32.toJson(this._amount);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get itemKey() {
    return this._hasItemKey ? this._itemKey : JsonToString.default;
  }
  get hasItemKey() {
    return this._hasItemKey;
  }
  setItemKey(path, value) {
    return {type: 'SET', path: path.concat(['itemKey']), value};
  }
  deleteItemKey(path) {
    return {type: 'DELETE', path: path.concat(['itemKey'])};
  }
  /**
   * @returns {number}
   */
  get amount() {
    return this._hasAmount ? this._amount : JsonToInt32.default;
  }
  get hasAmount() {
    return this._hasAmount;
  }
  setAmount(path, value) {
    return {type: 'SET', path: path.concat(['amount']), value};
  }
  deleteAmount(path) {
    return {type: 'DELETE', path: path.concat(['amount'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "itemKey": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignRewardData_LevelReward(this);
              copy._hasItemKey = true;
              copy._itemKey = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasItemKey) {
                return this;
              }
              const copy = new CampaignRewardData_LevelReward(this);
              copy._hasItemKey = false;
              copy._itemKey = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "amount": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignRewardData_LevelReward(this);
              copy._hasAmount = true;
              copy._amount = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAmount) {
                return this;
              }
              const copy = new CampaignRewardData_LevelReward(this);
              copy._hasAmount = false;
              copy._amount = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CampaignRewardData_LevelReward} other
   * @returns {CampaignRewardData_LevelReward}
   */
  merge(other) {
    const copy = new CampaignRewardData_LevelReward(this);
    if (other._hasItemKey) {
      copy._hasItemKey = true;
      copy._itemKey = other._itemKey;
    }
    if (other._hasAmount) {
      copy._hasAmount = true;
      copy._amount = other._amount;
    }
    return copy;
  }
}
CampaignRewardData_LevelReward.default = new CampaignRewardData_LevelReward();
class CampaignRewardData_LevelReward_Builder {
  constructor(value) {
    this._value = new CampaignRewardData_LevelReward(value);
  }
  build() {
    return new CampaignRewardData_LevelReward(this._value);
  }
  setItemKey(value) {
    this._value._hasItemKey = true;
    this._value._itemKey = value;
    return this;
  }
  deleteItemKey() {
    this._value._hasItemKey = false;
    this._value._itemKey = null;
    return this;
  }
  setAmount(value) {
    this._value._hasAmount = true;
    this._value._amount = value;
    return this;
  }
  deleteAmount() {
    this._value._hasAmount = false;
    this._value._amount = null;
    return this;
  }
}
CampaignRewardData_LevelReward.Builder = CampaignRewardData_LevelReward_Builder;
class CampaignRewardData_LevelReward_WithParent {
  /**
   * @param {CampaignRewardData_LevelReward} value
   * @param {CampaignRewardData_LevelReward_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CampaignRewardData_LevelReward.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasItemKey() {
    if (this._cachedHasItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedHasItemKey = true;
      } else {
        this._cachedHasItemKey = this._parent ? this._parent.hasItemKey : false;
      }
    }
    return this._cachedHasItemKey;
  }
  get itemKey() {
    if (this._cachedItemKey === undefined) {
      if (this._value.hasItemKey) {
        this._cachedItemKey = this._value.itemKey;
      } else {
        this._cachedItemKey = this._parent ? this._parent.itemKey : this._value.itemKey;
      }
    }
    return this._cachedItemKey;
  }
  get hasAmount() {
    if (this._cachedHasAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedHasAmount = true;
      } else {
        this._cachedHasAmount = this._parent ? this._parent.hasAmount : false;
      }
    }
    return this._cachedHasAmount;
  }
  get amount() {
    if (this._cachedAmount === undefined) {
      if (this._value.hasAmount) {
        this._cachedAmount = this._value.amount;
      } else {
        this._cachedAmount = this._parent ? this._parent.amount : this._value.amount;
      }
    }
    return this._cachedAmount;
  }
  update(current, parent) {
    const result = new CampaignRewardData_LevelReward_WithParent(current, parent);
    return result;
  }
}
CampaignRewardData_LevelReward_WithParent.default = new CampaignRewardData_LevelReward_WithParent(CampaignRewardData_LevelReward.default, null);
CampaignRewardData_LevelReward.WithParent = CampaignRewardData_LevelReward_WithParent;
class CampaignRewardData_LevelReward_Descriptor {
  get itemKey() {
    if (!this._itemKey) {
      this._itemKey = {
        name: "itemKey",
        Name: "ItemKey",
        number: 1,
        protoType: 9,
        protoName: "item_key",
        type: JsonToString,
        options: {
          valueDropdown: "RewardItemKeyList",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._itemKey;
  }
  get amount() {
    if (!this._amount) {
      this._amount = {
        name: "amount",
        Name: "Amount",
        number: 2,
        protoType: 5,
        protoName: "amount",
        type: JsonToInt32,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._amount;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.itemKey,
        this.amount,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForItemKey",
        Name: "DummyOneofForItemKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAmount",
        Name: "DummyOneofForAmount",
        fields: [
          this.fields[1],
        ],
      });
    }
    return this._oneofs;
  }
}
CampaignRewardData_LevelReward.descriptor = new CampaignRewardData_LevelReward_Descriptor();
class CampaignRewardData_CampaignReward {
  get descriptor() {
    return CampaignRewardData_CampaignReward.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._rewards = [];
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._rewards.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CampaignRewardData_CampaignReward) {
      return value;
    }
    return CampaignRewardData_CampaignReward.fromJson(value);
  }
  static fromJson(json) {
    const result = new CampaignRewardData_CampaignReward();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    result._rewards = JsonToList(json.rewards, CampaignRewardData_LevelReward);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._rewards.length > 0) {
      result.rewards = ArrayToJson(this._rewards, CampaignRewardData_LevelReward);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {CampaignRewardData_LevelReward[]}
   */
  get rewards() {
    return this._rewards;
  }
  addRewards(path, value) {
    return {type: 'ADD', path: path.concat(['rewards']), value: value.toJson()};
  }
  setRewards(path, value) {
    return {type: 'SET', path: path.concat(['rewards']), value: ArrayToJson(value, CampaignRewardData_LevelReward)};
  }
  setRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['rewards', key]), value: value.toJson()};
  }
  deleteRewards(path) {
    return {type: 'DELETE', path: path.concat(['rewards'])};
  }
  deleteRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['rewards', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignRewardData_CampaignReward(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new CampaignRewardData_CampaignReward(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "rewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignRewardData_CampaignReward(this);
              copy._rewards = [];        for (let i of value) {
                copy._rewards.push(CampaignRewardData_LevelReward.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CampaignRewardData_CampaignReward(this);
              copy._rewards = copy._rewards.concat([CampaignRewardData_LevelReward.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._rewards.length === 0) {
                return this;
              }
              const copy = new CampaignRewardData_CampaignReward(this);
              copy._rewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CampaignRewardData_CampaignReward(this);
              copy._rewards = copy._rewards.slice();
              copy._rewards[path[1]] = CampaignRewardData_LevelReward.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CampaignRewardData_CampaignReward(this);
              copy._rewards = copy._rewards.slice(0, path[1]).concat(copy._rewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._rewards.length) {
            return this;
          }
          const oldValue = this._rewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CampaignRewardData_CampaignReward(this);
          copy._rewards = copy._rewards.slice();
          copy._rewards[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CampaignRewardData_CampaignReward} other
   * @returns {CampaignRewardData_CampaignReward}
   */
  merge(other) {
    const copy = new CampaignRewardData_CampaignReward(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    copy._rewards = this._rewards.concat(other._rewards);
    return copy;
  }
}
CampaignRewardData_CampaignReward.default = new CampaignRewardData_CampaignReward();
class CampaignRewardData_CampaignReward_Builder {
  constructor(value) {
    this._value = new CampaignRewardData_CampaignReward(value);
  }
  build() {
    return new CampaignRewardData_CampaignReward(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  addAllRewards(values) {
    this._value._rewards = this._value._rewards.concat(values);
    return this;
  }
  addRewards(value) {
    this._value._rewards = this._value._rewards.concat([value]);
    return this;
  }
  setRewards(index, value) {
    this._value._rewards = this._value._rewards.concat();
    this._value._rewards[index] = value;
    return this;
  }
  clearRewards() {
    this._value._rewards = [];
    return this;
  }
}
CampaignRewardData_CampaignReward.Builder = CampaignRewardData_CampaignReward_Builder;
class CampaignRewardData_CampaignReward_WithParent {
  /**
   * @param {CampaignRewardData_CampaignReward} value
   * @param {CampaignRewardData_CampaignReward_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CampaignRewardData_CampaignReward.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get selfRewards() {
    if (!this._selfRewards) {
      this._selfRewards = [];
      for (let i of this._value.rewards) {
        this._selfRewards.push(new CampaignRewardData_LevelReward.WithParent(i, null));
      }
    }
    return this._selfRewards;
  }
  get inherentRewards() {
    if (!this._inherentRewards) {
      this._inherentRewards = this._parent ? this._parent.rewards : [];
    }
    return this._inherentRewards;
  }
  get rewards() {
    if (!this._allRewards) {
      this._allRewards = this._parent ? this._parent.rewards.concat(this.selfRewards) : this.selfRewards;
    }
    return this._allRewards;
  }
  update(current, parent) {
    const result = new CampaignRewardData_CampaignReward_WithParent(current, parent);
    if (this._selfRewards) {
      if (this._value.rewards === current.rewards) {
        result._selfRewards = this._selfRewards;
      } else {
        result._selfRewards = [];
        for (let i = 0; i < current.rewards.length; i++) {
          const oldValue = this._value.rewards[i];
          if (oldValue) {
            const oldCache = this._selfRewards[i];
            if (oldValue === current.rewards[i]) {
              result._selfRewards[i] = oldCache;
            } else {
              result._selfRewards[i] = oldCache.update(current.rewards[i], null);
            }
          } else {
            result._selfRewards[i] = new CampaignRewardData_LevelReward.WithParent(current.rewards[i], null);
          }
        }
      }
    }
    return result;
  }
}
CampaignRewardData_CampaignReward_WithParent.default = new CampaignRewardData_CampaignReward_WithParent(CampaignRewardData_CampaignReward.default, null);
CampaignRewardData_CampaignReward.WithParent = CampaignRewardData_CampaignReward_WithParent;
class CampaignRewardData_CampaignReward_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get rewards() {
    if (!this._rewards) {
      this._rewards = {
        name: "rewards",
        Name: "Rewards",
        number: 2,
        protoType: 11,
        protoName: "rewards",
        type: CampaignRewardData_LevelReward,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._rewards;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.rewards,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
    }
    return this._oneofs;
  }
}
CampaignRewardData_CampaignReward.descriptor = new CampaignRewardData_CampaignReward_Descriptor();
export class CampaignRewardData {
  get descriptor() {
    return CampaignRewardData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._campaignRewards = [];
  }
  isEmpty() {
    if (this._campaignRewards.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof CampaignRewardData) {
      return value;
    }
    return CampaignRewardData.fromJson(value);
  }
  static fromJson(json) {
    const result = new CampaignRewardData();
    result._campaignRewards = JsonToList(json.campaignRewards, CampaignRewardData_CampaignReward);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._campaignRewards.length > 0) {
      result.campaignRewards = ArrayToJson(this._campaignRewards, CampaignRewardData_CampaignReward);
    }
    return result;
  }
  /**
   * @returns {CampaignRewardData_CampaignReward[]}
   */
  get campaignRewards() {
    return this._campaignRewards;
  }
  addCampaignRewards(path, value) {
    return {type: 'ADD', path: path.concat(['campaignRewards']), value: value.toJson()};
  }
  setCampaignRewards(path, value) {
    return {type: 'SET', path: path.concat(['campaignRewards']), value: ArrayToJson(value, CampaignRewardData_CampaignReward)};
  }
  setCampaignRewardsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['campaignRewards', key]), value: value.toJson()};
  }
  deleteCampaignRewards(path) {
    return {type: 'DELETE', path: path.concat(['campaignRewards'])};
  }
  deleteCampaignRewardsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['campaignRewards', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "campaignRewards": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new CampaignRewardData(this);
              copy._campaignRewards = [];        for (let i of value) {
                copy._campaignRewards.push(CampaignRewardData_CampaignReward.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new CampaignRewardData(this);
              copy._campaignRewards = copy._campaignRewards.concat([CampaignRewardData_CampaignReward.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._campaignRewards.length === 0) {
                return this;
              }
              const copy = new CampaignRewardData(this);
              copy._campaignRewards = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._campaignRewards.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new CampaignRewardData(this);
              copy._campaignRewards = copy._campaignRewards.slice();
              copy._campaignRewards[path[1]] = CampaignRewardData_CampaignReward.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new CampaignRewardData(this);
              copy._campaignRewards = copy._campaignRewards.slice(0, path[1]).concat(copy._campaignRewards.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._campaignRewards.length) {
            return this;
          }
          const oldValue = this._campaignRewards[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new CampaignRewardData(this);
          copy._campaignRewards = copy._campaignRewards.slice();
          copy._campaignRewards[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {CampaignRewardData} other
   * @returns {CampaignRewardData}
   */
  merge(other) {
    const copy = new CampaignRewardData(this);
    copy._campaignRewards = this._campaignRewards.concat(other._campaignRewards);
    return copy;
  }
}
CampaignRewardData.default = new CampaignRewardData();
CampaignRewardData.LevelReward = CampaignRewardData_LevelReward;
CampaignRewardData.CampaignReward = CampaignRewardData_CampaignReward;
class CampaignRewardData_Builder {
  constructor(value) {
    this._value = new CampaignRewardData(value);
  }
  build() {
    return new CampaignRewardData(this._value);
  }
  addAllCampaignRewards(values) {
    this._value._campaignRewards = this._value._campaignRewards.concat(values);
    return this;
  }
  addCampaignRewards(value) {
    this._value._campaignRewards = this._value._campaignRewards.concat([value]);
    return this;
  }
  setCampaignRewards(index, value) {
    this._value._campaignRewards = this._value._campaignRewards.concat();
    this._value._campaignRewards[index] = value;
    return this;
  }
  clearCampaignRewards() {
    this._value._campaignRewards = [];
    return this;
  }
}
CampaignRewardData.Builder = CampaignRewardData_Builder;
class CampaignRewardData_WithParent {
  /**
   * @param {CampaignRewardData} value
   * @param {CampaignRewardData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return CampaignRewardData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfCampaignRewards() {
    if (!this._selfCampaignRewards) {
      this._selfCampaignRewards = [];
      for (let i of this._value.campaignRewards) {
        this._selfCampaignRewards.push(new CampaignRewardData_CampaignReward.WithParent(i, null));
      }
    }
    return this._selfCampaignRewards;
  }
  get inherentCampaignRewards() {
    if (!this._inherentCampaignRewards) {
      this._inherentCampaignRewards = this._parent ? this._parent.campaignRewards : [];
    }
    return this._inherentCampaignRewards;
  }
  get campaignRewards() {
    if (!this._allCampaignRewards) {
      this._allCampaignRewards = this._parent ? this._parent.campaignRewards.concat(this.selfCampaignRewards) : this.selfCampaignRewards;
    }
    return this._allCampaignRewards;
  }
  update(current, parent) {
    const result = new CampaignRewardData_WithParent(current, parent);
    if (this._selfCampaignRewards) {
      if (this._value.campaignRewards === current.campaignRewards) {
        result._selfCampaignRewards = this._selfCampaignRewards;
      } else {
        result._selfCampaignRewards = [];
        for (let i = 0; i < current.campaignRewards.length; i++) {
          const oldValue = this._value.campaignRewards[i];
          if (oldValue) {
            const oldCache = this._selfCampaignRewards[i];
            if (oldValue === current.campaignRewards[i]) {
              result._selfCampaignRewards[i] = oldCache;
            } else {
              result._selfCampaignRewards[i] = oldCache.update(current.campaignRewards[i], null);
            }
          } else {
            result._selfCampaignRewards[i] = new CampaignRewardData_CampaignReward.WithParent(current.campaignRewards[i], null);
          }
        }
      }
    }
    return result;
  }
}
CampaignRewardData_WithParent.default = new CampaignRewardData_WithParent(CampaignRewardData.default, null);
CampaignRewardData.WithParent = CampaignRewardData_WithParent;
class CampaignRewardData_Descriptor {
  get campaignRewards() {
    if (!this._campaignRewards) {
      this._campaignRewards = {
        name: "campaignRewards",
        Name: "CampaignRewards",
        number: 1,
        protoType: 11,
        protoName: "campaign_rewards",
        type: CampaignRewardData_CampaignReward,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._campaignRewards;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.campaignRewards,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
CampaignRewardData.descriptor = new CampaignRewardData_Descriptor();
